// extracted by css-extract-rspack-plugin
export default {"lede":"Lede-module__lede__iV_KO"};